import { RootState } from 'store/rootTypes';

export const StoresSelector = (state: RootState) => state.Stores;
